/* Reef Lagoon — Classics Rail behaviour.
 * - Prev/next arrows scroll ~1.5 cards, disable at each end (keyboard-accessible buttons).
 * - Right-edge "more" mask removed at the end via the .rcr--end class.
 * - Scroll-reveal: IntersectionObserver + stagger, shown immediately under reduced-motion / no-IO.
 * - Idempotent; re-inits on the theme editor's shopify:section:load. transform/opacity only. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function step(track) {
    var card = track.querySelector('[data-rcr-card]');
    if (!card) return track.clientWidth * 0.8;
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return (card.offsetWidth + gap) * 1.5;
  }

  function updateEnds(root, track, prev, next) {
    var max = track.scrollWidth - track.clientWidth;
    var x = track.scrollLeft;
    var atStart = x <= 1;
    var atEnd = x >= max - 1;
    if (prev) prev.disabled = atStart;
    if (next) next.disabled = atEnd;
    root.classList.toggle('rcr--end', atEnd || max <= 1);
  }

  function initReveal(root) {
    var cards = root.querySelectorAll('[data-rcr-card]');
    if (reduce || !('IntersectionObserver' in window)) {
      for (var i = 0; i < cards.length; i++) cards[i].classList.add('is-in');
      return;
    }
    root.classList.add('rcr--observe');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var idx = [].indexOf.call(cards, e.target);
        window.setTimeout(function () { e.target.classList.add('is-in'); }, (idx < 0 ? 0 : idx) * 90);
        io.unobserve(e.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    for (var k = 0; k < cards.length; k++) io.observe(cards[k]);
  }

  function initRail(root) {
    if (!root || root.dataset.rcrInit === '1') return;
    root.dataset.rcrInit = '1';

    var track = root.querySelector('[data-rcr-track]');
    if (!track) return;
    var prev = root.querySelector('[data-rcr-prev]');
    var next = root.querySelector('[data-rcr-next]');

    initReveal(root);

    function scrollBy(dir) {
      track.scrollBy({ left: dir * step(track), behavior: reduce ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
    if (next) next.addEventListener('click', function () { scrollBy(1); });

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateEnds(root, track, prev, next);
        ticking = false;
      });
    }
    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    updateEnds(root, track, prev, next);
  }

  function initAll() {
    var els = document.querySelectorAll('[data-rcr]');
    for (var i = 0; i < els.length; i++) initRail(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('[data-rcr]') : null;
    if (el) { initRail(el); } else { initAll(); }
  });
})();
